import { render } from "./Icon.vue?vue&type=template&id=0e48cbb2"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
script.render = render

export default script